import styled from 'styled-components';

const PricingPageContainer = styled.div`
    padding-top: var(--section-padding);
    padding-bottom: var(--section-padding);
    .plans {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
        gap: 30px;
    }
    .contact-text {
        text-align: center;
        margin: 50px auto 20px;
        font-size: 20px;
    }
    .contact-link {
        display: block;
        width: fit-content;
        margin: 20px auto;
        background-color: var(--main-color);
        color: white;
        padding: 15px 30px;
        text-decoration: none;
    }
`;
export default PricingPageContainer;
